// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"001adf25","284":"746a7ca1","313":"3c7aa6c4","541":"214a3820","593":"46d16c52","672":"fece77da","900":"20d40b08","933":"dde92a18"}[chunkId] + ".chunk.js";
};